// import React, { useEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";
import React from "react";

interface MarqueeProps {
  direction?: "left" | "right"; // Scroll direction (default: "left")
  children?: React.ReactNode; // Marquee content
}

// const Marquee: React.FC<MarqueeProps> = ({
//   speed = 5,
//   direction = "left",
//   reverse = false,
//   children,
// }) => {
//   const marqueeRef = useRef<HTMLDivElement | null>(null);
//   const [scrollPosition, setScrollPosition] = useState(0);

//   // Determine final direction based on reverse flag
//   const finalDirection = direction;
//   const directionMultiplier = finalDirection === "left" ? -1 : 1;

//   useEffect(() => {
//     if (!marqueeRef.current) return;

//     const marqueeWidth = marqueeRef.current.offsetWidth;
//     const contentWidth = marqueeRef.current.scrollWidth;

//     const scroll = () => {
//       setScrollPosition((prev) => {
//         if (Math.abs(prev) >= contentWidth) return 0; // Reset position for seamless loop
//         return prev + directionMultiplier * speed;
//       });
//     };

//     const intervalId = setInterval(scroll, 16); // 60 FPS update

//     return () => clearInterval(intervalId); // Cleanup on unmount
//   }, [finalDirection, speed]);

//   return (
//     <div
//       ref={marqueeRef}
//       className="w-full overflow-hidden before-after whitespace-nowrap relative"
//       style={{ display: "flex" }}
//     >
//       <div
//         style={{
//           transform: `translateX(${scrollPosition}px)`,
//           display: "inline-flex",
//         }}
//       >
//         {children}
//       </div>
//     </div>
//   );
// };

// export default Marquee;

const CustomerReviews: React.FC<MarqueeProps> = ({ children, direction }) => {
  return (
    <div className="relative before-after">
      <Marquee direction={direction}>{children}</Marquee>
    </div>
  );
};
export default CustomerReviews;
